import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import remarkBreaks from 'remark-breaks';
import Markdown from 'components/common/Markdown';
import { KbArticle, KbFolder } from '../types';
import { getFolderPath } from '../utils/getFolderPath';
import {
  ContentArea,
  ContentHeader,
  ContentTitle,
  ContentMeta,
  ContentActions,
  ContentBody,
  ActionButton,
  MarkdownContent,
  Breadcrumbs,
} from '../styles';

interface Props {
  article: KbArticle;
  folders: KbFolder[];
  onEdit: () => void;
  onShowVersions: () => void;
  onDelete: () => void;
}

const ArticleViewer: React.FC<Props> = ({ article, folders, onEdit, onShowVersions, onDelete }) => {
  const path = getFolderPath(folders, article.folderId);

  return (
    <ContentArea>
      <ContentHeader>
        <div>
          {path.length > 0 && (
            <Breadcrumbs>
              {path.map((name, i) => (
                <span key={i}>{name}{i < path.length - 1 ? ' / ' : ' / '}</span>
              ))}
            </Breadcrumbs>
          )}
          <ContentTitle>
            {article.protected && (
              <FontAwesomeIcon
                icon={faLock}
                title="Token-protected: managed externally (kb_sync), read-only"
                style={{ fontSize: 14, color: '#999', marginRight: 8 }}
              />
            )}
            {article.title}
          </ContentTitle>
          <ContentMeta>
            Last updated by {article.updatedBy} on {article.updatedAt}
            {article.protected && ' · read-only (managed by kb_sync)'}
          </ContentMeta>
        </div>
        <ContentActions>
          <ActionButton onClick={onShowVersions}>History</ActionButton>
          {!article.protected && (
            <>
              <ActionButton $primary onClick={onEdit}>Edit</ActionButton>
              <ActionButton $danger onClick={onDelete}>Delete</ActionButton>
            </>
          )}
        </ContentActions>
      </ContentHeader>
      <ContentBody>
        <MarkdownContent>
          <Markdown plugins={[remarkBreaks]}>{article.content}</Markdown>
        </MarkdownContent>
      </ContentBody>
    </ContentArea>
  );
};

export default ArticleViewer;
